import styled from "styled-components";

export const SliderLabelWrapper = styled.button<{
  $left?: number;
}>`
  position: ${({ $left }) =>
          typeof $left === "number" ? "absolute" : "relative"};
  height: 10px;
  left: ${({ $left }) => `${$left}%`};
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${({ $left }) =>
          typeof $left === "number" ? "translateX(-50%)" : "revert"};
  color: ${({ theme }) => theme.colors.default[300]};
  white-space: nowrap;

  &:focus-within {
    outline: 2px solid ${({ theme }) => theme.colors.outline};
  }
`;
